import React, { createContext, useContext, useMemo } from 'react';
import { useFetch, CPLAT_API_ROUTES } from '@/api';
import { useAppSelector } from '@/redux/store';
import type { Monitoring, MonitoringGoodsDetail } from '@/types/api';
// 1. Context 생성
type MonitoringGoodsContextType = {
  goods: MonitoringGoodsDetail[];
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
};

const MonitoringGoodsContext = createContext<MonitoringGoodsContextType | undefined>(undefined);

// 2. Provider 구현
export const MonitoringGoodsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const user = useAppSelector((state) => state.user);

  // react-query로 데이터 패칭
  // API 호출
  const { data, isLoading, isError, refetch } = useFetch<{ data: Monitoring[] }>(
    CPLAT_API_ROUTES.getUserMonitoringGoods,
    {
      method: 'POST',
      params: {
        cplatToken: user.CplatToken,
      },
    },
  );

  // 상품 리스트만 추출
  const goods = useMemo(() => data?.data[0]?.MonitoringGoodsDetailList ?? [], [data]);

  // 컨텍스트 값
  const value = useMemo(
    () => ({ goods, isLoading, isError, refetch }),
    [goods, isLoading, isError, refetch],
  );

  return (
    <MonitoringGoodsContext.Provider value={value}>{children}</MonitoringGoodsContext.Provider>
  );
};

// 3. 커스텀 훅
export const useMonitoringGoods = () => {
  const context = useContext(MonitoringGoodsContext);
  if (!context) throw new Error('useMonitoringGoods must be used within MonitoringGoodsProvider');
  return context;
};
